import { Button } from '@/components/tiptap-editor/tiptap-ui-primitive/button';
import { CircleFadingArrowUp } from 'lucide-react';

export const ZyAnimatorVersionConversionButton = ({
    disabled,
    onOpenConversionDialog,
}: {
    disabled: boolean;
    onOpenConversionDialog: () => void;
}) => {
    return (
        <Button
            aria-label="Convert to V2"
            className="cursor-pointer rounded p-1.5 text-gray-600 !bg-transparent transition-colors hover:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-700"
            disabled={disabled}
            onClick={onOpenConversionDialog}
            showTooltip={true}
            tooltip="Convert to V2 to edit"
        >
            <CircleFadingArrowUp className="h-4 w-4" />
        </Button>
    );
};
